/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsShiftAvailableStationOutput } from "../../entities/models/ShiftAvailableStationOutput";
import { modelsShiftOccupiedIntervalSchema } from "./shiftOccupiedIntervalSchema";
import { z } from "zod/v4";

export const modelsShiftAvailableStationOutputSchema = z.object({
    get "occupied_intervals"(){
                return z.array(modelsShiftOccupiedIntervalSchema).optional()
              },
"station_id": z.optional(z.int()),
"station_name": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsShiftAvailableStationOutput>